var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimeZone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12.109,
    viewBox: "0 0 14 12.109",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13617 6207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.945,10.419c-.3.526-.635.825-.914.825-.712,0-1.76-1.887-1.86-4.757H6.249a4.338,4.338,0,0,1,.378-.865H4.169c.1-2.87,1.148-4.757,1.86-4.757.6,0,1.426,1.342,1.737,3.467a4.266,4.266,0,0,1,.809-.487,7.661,7.661,0,0,0-.964-2.73,5.188,5.188,0,0,1,2.9,2.361,4.245,4.245,0,0,1,1.061.184A6.036,6.036,0,1,0,6.03,12.109,5.989,5.989,0,0,0,8.4,11.624,4.3,4.3,0,0,1,6.945,10.419Zm-2.5-9.3A9.282,9.282,0,0,0,3.3,5.622H.883A5.2,5.2,0,0,1,4.448,1.116ZM.883,6.487H3.3a9.268,9.268,0,0,0,1.149,4.506A5.2,5.2,0,0,1,.883,6.487Z",
    transform: "translate(13617 -6207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.051,32.609a3.443,3.443,0,1,0,3.443,3.442A3.446,3.446,0,0,0,13.051,32.609Zm0,6.065a2.622,2.622,0,1,1,2.623-2.623A2.625,2.625,0,0,1,13.051,38.674Z",
    transform: "translate(13614.506 -6235.176)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.114,34.087H13.3v2.25a.419.419,0,0,0,.119.293l1.484,1.517.573-.585-1.366-1.4Z",
    transform: "translate(13613.862 -6235.457)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimeZone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/time-zone.997f2e6c84bd7a1573b86ea780c8866a.svg";